import { render, staticRenderFns } from "./List-Distribution-Center-Link.vue?vue&type=template&id=a08668c6"
import script from "./List-Distribution-Center-Link.vue?vue&type=script&lang=js"
export * from "./List-Distribution-Center-Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports